import { ApiQuery, SortDirections } from "../filters/types";
import { AssetColumns } from "./types";

// // // //

export const DEFAULT_ASSET_LIST_QUERY: ApiQuery = {
    sort: {
        direction: SortDirections.asc,
        field: AssetColumns.name,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};
